/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureEnumsResponseDto } from '../../models/backend-venture-enums-response-dto';

export interface VentureFundsVentureFundsEnumsRetrieve$Params {}

export function ventureFundsVentureFundsEnumsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: VentureFundsVentureFundsEnumsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureEnumsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundsEnumsRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureEnumsResponseDto>;
    }),
  );
}

ventureFundsVentureFundsEnumsRetrieve.PATH = '/api/venture_funds/venture-funds-enums/';
